module.exports = __webpack_public_path__ + "41639087f3bd1ded8436ff9891f8a960.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-3.png
// module id = 2857
// module chunks = 0